
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';
  import steamService from '@/services/steam.service';

  @Component({
    computed: {
      ...mapGetters([
        'redirectUrl'
      ])
    }
  })
  export default class SteamLink extends Vue {
    created() {
      steamService.goToSteam(this, this.$store.getters.redirectUrl);
    }
  }
